import { Smartphone } from "lucide-react";

export const RotateHint = () => (
  <div data-testid="rotate-hint" className="rotate-hint fixed inset-0 z-[100] glass items-center justify-center flex-col gap-6 text-center px-10">
    <Smartphone className="w-14 h-14 text-amber-400 rotate-90" />
    <h2 className="text-lg">Rotate your device</h2>
    <p className="text-sm text-slate-400">The table is played in landscape. Turn your phone sideways to continue.</p>
  </div>
);
